import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from './utils/animations';

const Cookies = () => {
  useEffect(() => {
    document.title = "Cookies Policy | forca.dev";
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      variants={staggerContainer(0.1, 0.1)}
      initial="hidden"
      animate="show"
      className="pt-24 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <motion.h1 
          variants={fadeIn('down', 0.2)}
          className="text-3xl md:text-4xl font-bold text-white mb-8 text-center"
        >
          Cookies Policy
        </motion.h1>

        <motion.div
          variants={fadeIn('up', 0.3)}
          className="prose prose-invert prose-slate max-w-none"
        >
          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 md:p-8 shadow-xl">
            <p className="text-slate-300">Last Updated: May 7, 2025</p>

            <h2>1. Introduction</h2>
            <p>
              This Cookies Policy explains how forca.dev uses cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
            </p>

            <h2>2. What Are Cookies?</h2>
            <p>
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.
            </p>

            <h2>3. Why Do We Use Cookies?</h2>
            <p>
              We use cookies for several reasons:
            </p>
            <ul>
              <li>Essential cookies: Necessary for the website to function properly</li>
              <li>Performance cookies: To understand how visitors interact with our website</li>
              <li>Functionality cookies: To remember your preferences and settings</li>
              <li>Targeting/advertising cookies: To deliver relevant content and advertisements</li>
            </ul>

            <h2>4. Types of Cookies We Use</h2>
            <p>
              We use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on your device until you delete them).
            </p>

            <h2>5. How to Control Cookies</h2>
            <p>
              You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality may be restricted.
            </p>

            <h2>6. Third-Party Cookies</h2>
            <p>
              Some cookies may be placed by third parties when you visit our website. These third parties may include analytics providers, advertising networks, and social media platforms.
            </p>

            <h2>7. Updates to This Policy</h2>
            <p>
              We may update this Cookies Policy from time to time to reflect changes in technology, regulation, or our business practices. Any changes will become effective when we post the revised policy.
            </p>

            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about our use of cookies, please contact us at:
            </p>
            <p className="text-cyan-400">info@forca.dev</p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Cookies;